var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3828 0 0 5.3828 0 12C0 18.6172 5.3828 24 12 24C18.6172 24 24 18.6172 24 12C24 5.3828 18.6172 0 12 0ZM11.5 20C10.6728 20 9.99998 19.3272 9.99998 18.5C9.99998 17.6729 10.6728 17 11.5 17C12.3271 17 13 17.6729 13 18.5C13 19.3272 12.3271 20 11.5 20ZM13 13.9004V15.5C13 15.7764 12.7763 16 12.5 16H10.5C10.2236 16 9.99998 15.7764 9.99998 15.5V13C9.99998 11.8975 10.8975 11 12 11C13.1025 11 14 10.1025 14 9C14 7.89745 13.1025 6.99998 12 6.99998C10.8975 6.99998 9.99998 7.89745 9.99998 9V9.50002C9.99998 9.77639 9.77634 10 9.49997 10H7.5C7.22363 10 6.99998 9.77639 6.99998 9.50002V9C6.99998 6.24314 9.24314 3.99998 12 3.99998C14.7569 3.99998 17 6.24319 17 9C17 11.3994 15.3096 13.4326 13 13.9004Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.c8d9d9a849fb99663c5a5ec8baf13c17.svg";
export { ForwardRef as ReactComponent };